import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button, Chip } from '@mui/material';
import { useNotificationSummary } from '../../components/notifications/NotificationBell';
import { statusSx } from '../../config/platformModules';

// 대시보드 "처리할 일" — 승인 대기 가입 (N1, 12.01-D011). 없으면 표시하지 않음
function TodoCard({ user }) {
  const navigate = useNavigate();
  const { summary } = useNotificationSummary(user?.role === 'admin');
  if (user?.role !== 'admin' || !summary.total) return null;
  return (
    <Box sx={{ background: 'white', borderRadius: '20px', boxShadow: '0px 4px 20px rgba(0,0,0,0.06)', p: 2, mb: 2, border: '1px solid #FFE0B2' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1, gap: 1, flexWrap: 'wrap' }}>
        <Typography sx={{ fontWeight: 700, fontSize: 15 }}>
          처리할 일 <Chip size="small" label={`승인 대기 ${summary.total}`} sx={{ ml: 1, ...statusSx('warn') }} />
        </Typography>
        <Button size="small" onClick={() => navigate('/user')}>사용자 화면</Button>
      </Box>
      {summary.items.slice(0, 5).map((it) => (
        <Box key={it.id} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 0.75, borderTop: '1px solid #f1f1f1', gap: 1 }}>
          <Box sx={{ minWidth: 0 }}>
            <Typography noWrap sx={{ fontSize: 14, fontWeight: 600 }}>{it.title}</Typography>
            <Typography noWrap variant="caption" color="text.secondary">{it.subtitle}</Typography>
          </Box>
          <Button size="small" variant="contained" sx={{ flexShrink: 0, bgcolor: '#551FFF' }} onClick={() => navigate(it.link)}>승인 검토</Button>
        </Box>
      ))}
    </Box>
  );
}

export default TodoCard;
